<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h4 class="text-uppercase">{{'IDS_SEARCH_COA' | translate}}</h4>
    </div>
    <div class="mt-3">
        <p class="text-muted">
            {{'IDS_SEARCH_DESCRIPTION_CERTIFICATE' | translate}}
        </p>
    </div>
    <div class="d-flex justify-content-center mt-3">
        <label class="text-muted fw-bold" for="searchCodeInput">{{'IDS_CODE' | translate}}:</label>
    </div>
    <div class="d-flex justify-content-center">
        <input
            id="searchCodeInput"
            class="dialog-input"
            type="text"
            name="searchCode"
            [placeholder]="'IDS_CODE' | translate"
            [attr.aria-label]="'IDS_CODE' | translate"
            [ngModel]="searchCode()"
            (ngModelChange)="searchCode.set($event)"
            (keydown.enter)="searchCertificate()">
    </div>
    @if(isError()){
    <div class="d-flex justify-content-center mt-3" role="alert" aria-live="polite">
      <span class="dialog-centered warning">{{ 'IDS_NO_RESULTS' | translate }}</span>
    </div>
    }
    <div class="d-flex justify-content-center my-3">
        <button class="btn-gold text-uppercase fw-bold" type="button" (click)="searchCertificate()">{{'IDS_SEARCH' | translate}}</button>
    </div>
</div>
